import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// import { PartnersAddEditComponent, SelectParameterTypeDialog } from './partners-add-edit/partners-add-edit.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { MatSelectModule } from '@angular/material/select';
import { NgxMaskModule } from 'ngx-mask';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxPaginationModule } from 'ngx-pagination';
import {MatRadioModule} from '@angular/material/radio';
import { MatOptionModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatChipsModule } from '@angular/material/chips';
import { CaseTranformationPipe } from './case-tranformation.pipe';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LOCALE_ID } from "@angular/core";
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {DateAdapter, MatNativeDateModule} from '@angular/material/core';
import { LeadPartnersRoutingModule } from './lead-partners-routing.module';
import { LeadPartnersComponent } from './lead-partners.component';
import { PartnersListComponent } from './partners-list/partners-list.component';
import { PartnersAddEditComponent, SelectParameterTypeDialog } from './partners-add-edit/partners-add-edit.component';
import { EditLeadPartnerContentComponent } from './edit-lead-partner-content/edit-lead-partner-content.component';
import { EditLeadPartnerPopupContentComponent } from './edit-lead-partner-popup-content/edit-lead-partner-popup-content.component';
import { NgxMatTimepickerModule } from "ngx-mat-timepicker";
import { LeadPartnerPerformanceListComponent } from './lead-partner-performance-list/lead-partner-performance-list.component';
import { LeadPartnerPerformanceDetailsComponent } from './lead-partner-performance-details/lead-partner-performance-details.component';
import { PartnerDashbaordComponent } from './partner-dashbaord/partner-dashbaord.component';


const lang = "en-US";


@NgModule({
  declarations: [
    LeadPartnersComponent,
    PartnersListComponent,
    PartnersAddEditComponent,
    EditLeadPartnerContentComponent,
    EditLeadPartnerPopupContentComponent,
    CaseTranformationPipe,
    SelectParameterTypeDialog,
    LeadPartnerPerformanceListComponent,
    LeadPartnerPerformanceDetailsComponent,
    PartnerDashbaordComponent
  ],
  imports: [
    CommonModule,
    LeadPartnersRoutingModule,
    FurySharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatChipsModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    NgxPaginationModule,
    MatCheckboxModule,
    MatIconModule,
    MatOptionModule,
    ListModule,
    NgxMaskModule,
    MatDialogModule,
    SharedModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatTimepickerModule.setLocale(lang)
  ],
  providers: [{ provide: LOCALE_ID, useValue: lang }],
})
export class LeadPartnersModule { }
